// Store PCs save a preview image next to every clip: same address, with .jpg
// instead of .mp4 (e.g. …/clips/transaction-…Z.mp4 → …/clips/transaction-…Z.jpg).
// Older clips have no image; callers must cope with it failing to load.
export function clipThumbnailUrl(videoUrl) {
  if (!videoUrl || !/\.mp4(?=[?#]|$)/i.test(videoUrl)) return null;
  return videoUrl.replace(/\.mp4(?=[?#]|$)/i, '.jpg');
}
